import React, { Component } from "react";
import { connect } from "react-redux";
import "../style.css";
import { CircularProgress } from "@material-ui/core";
import Provinces from "./Provinces";
import lazyView from "../../common/lazyView";

const BDCMap = lazyView(() => import("./BDCMap"));

class index extends Component {
  state = {};
  render() {
    const {
      language,
      countriesFullyLoaded,
      selectedCountryID,
      settings,
      countries,
      address,
      temporaryAddress,
    } = this.props;
    return (
      <div style={{ marginTop: settings.enable_map_pin_selection ? 10 : 30 }}>
        {!settings.enable_map_pin_selection && (
          <p
            className="box-title"
            style={{ textAlign: language === "arabic" ? "right" : "left" }}
          >
            {language == "arabic" ? "العنوان" : "Location"}
          </p>
        )}
        <div
          className="bordered"
          style={{
            height: "100%",
            minHeight: 500,
            backgroundColor: "white",
            display: !countriesFullyLoaded && "grid",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          {countriesFullyLoaded ? (
            <div>
              {settings.enable_map_pin_selection ? (
                <BDCMap
                  height={
                    countries.length > 1
                      ? "calc(100vh - 400px)"
                      : "calc(100vh - 250px)"
                  }
                  branchDeliveryCharges={this.props.branch_delivery_charges}
                  onPinSelected={({
                    lat,
                    lng,
                    branchDeliveryChargeId,
                    country_id,
                    other_data,
                    street,
                    building,
                    block,
                    geocode_confidence,
                  }) => {
                    this.props.setTemporaryAddress({
                      lat,
                      lng,
                      branchDeliveryChargeId,
                      country_id,
                      street,
                      building,
                      block,
                    });
                    this.props.setBranchDeliveryChargeID(
                      branchDeliveryChargeId
                    );
                    this.props.setCountryID(country_id);
                    // this.props.modifyAddress({
                    //   lat: parseFloat(lat),
                    //   lng: parseFloat(lng),
                    //   gpsConfirmed: true,
                    //   street,
                    //   building,
                    //   block,
                    // });
                  }}
                  setLoading={this.props.setLoading}
                  lat={
                    temporaryAddress?.lat
                      ? parseFloat(temporaryAddress.lat)
                      : address?.lat
                      ? parseFloat(address.lat)
                      : undefined
                  }
                  lng={
                    temporaryAddress?.lng
                      ? parseFloat(temporaryAddress.lng)
                      : address?.lng
                      ? parseFloat(address.lng)
                      : undefined
                  }
                  isInsidePolygon={(v) => this.props.isInsidePolygon(v)}
                  selectedCountryID={selectedCountryID}
                  settings={settings}
                  language={language}
                />
              ) : (
                <Provinces
                  selectedCountryID={selectedCountryID}
                  setBranchDeliveryChargeID={
                    this.props.setBranchDeliveryChargeID
                  }
                  branchDeliveryChargeID={this.props.branchDeliveryChargeID}
                  setAddressesOpen={this.props.setAddressesOpen}
                  OpenBranchSelectDrawer={this.props.OpenBranchSelectDrawer}
                />
              )}
            </div>
          ) : (
            <CircularProgress
              color="primary"
              style={{
                alignSelf: "center",
                justifySelf: "center",
                width: 30,
                height: 30,
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countries: state.store.store.all_countries || state.store.store.countries,
    language: state.store.language,
    countriesFullyLoaded: !state.store.thirdLoading,
    settings: state.store.store.settings,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    address: state.customers.address,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (position) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: position }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
